import { defineComponent as _defineComponent } from 'vue'
import { unref, computed } from 'vue';
    import { IHotelDescription } from '@entities/hotelDescription/types/IDescription';
    import { useHotelDescriptionRepository } from '@entities/hotelDescription';
    import formatNumber from '@/js/common/Domain/Service/mixins/formatNumber';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'HotelDescriptionLocation',
  setup(__props) {

    const {
        hotelDescriptionLocationAddress, hotelDescriptionAirportName, hotelDescriptionAirportLocation, hotelDescriptionLocationDistance,
    } = useHotelDescriptionRepository();

    const isLocationAddressExists = computed(() => unref(hotelDescriptionLocationAddress).length > 0);

    const locationDistances = computed(() => {
        const distanceResult = [];
        if (unref(hotelDescriptionAirportLocation)) distanceResult.push(unref(hotelDescriptionAirportLocation));
        distanceResult.push(...unref(hotelDescriptionLocationDistance));
        return distanceResult;
    });
    const isLocationDistancesExist = computed(() => unref(locationDistances).length > 0);

    const hotelDescriptionLocationAddressText = computed(() => unref(hotelDescriptionLocationAddress).reduce((acc: string, location: IHotelDescription) => {
        acc += acc === '' ? `${location.value}` : `, ${location.value}`;
        return acc;
    }, ''));

return { __sfc: true,hotelDescriptionLocationAddress, hotelDescriptionAirportName, hotelDescriptionAirportLocation, hotelDescriptionLocationDistance, isLocationAddressExists, locationDistances, isLocationDistancesExist, hotelDescriptionLocationAddressText, formatNumber }
}

})